import React from 'react';
import { getCategoryFileArchiveData } from 'utils/apiRequests';

import { CategoryFileArchiveContext } from '.';

export class CategoryFileArchiveContextProvider extends React.Component {
	state = {
		fileArchive: null,
		isFetching: false,
	};

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		this.setState({ isFetching: true });
		getCategoryFileArchiveData()
			.then(fileArchive => {
				const modifiedFileArchive = fileArchive.map(file => {
					return {
						date: file.timestamp,
						userName: file.author_name,
						downloadUrl: file.download_url,
						fileName: file.filename,
						status: file.status,
					};
				});
				this.setState({ fileArchive: modifiedFileArchive });
				this.setState({ isFetching: false });
			})
			.catch(() => {
				this.setState({ fileArchive: [] });
				this.setState({ isFetching: false });
			});
	};

	render() {
		return (
			<CategoryFileArchiveContext.Provider
				value={{
					...this.state,
					refetch: this.fetchData,
				}}
			>
				{this.state.fileArchive ? this.props.children : null}
			</CategoryFileArchiveContext.Provider>
		);
	}
}
